import React, {Fragment} from 'react';

import {BulkDeleteButton} from 'react-admin';
import {
    BulkDisableMoviesButton,
    BulkEnableMoviesButton,
    BulkFeatureMoviesButton,
    BulkUnFeatureMoviesButton
} from "../buttons/enable-button";
import {BulkAddGenreButton} from "../buttons/add-genre-button";


export const MovieActions = props => (
    <Fragment>

        <BulkAddGenreButton {...props} />
        <BulkEnableMoviesButton {...props}/>
        <BulkDisableMoviesButton {...props}/>
        <BulkFeatureMoviesButton {...props}/>
        <BulkUnFeatureMoviesButton {...props}/>
        <BulkDeleteButton {...props}/>
    </Fragment>
);
